import React from "react";
// react plugin that creates an input with badges
import {globals,toolbox_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalToolbox } from '../../redux/modalSlice'; 
import { updateToolboxPartner, addToolboxPartner } from '../../redux/toolboxPartnerSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const ToolboxPartnerFormDialog = () => {
  const {toolboxModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("toolboxModal -> ",toolboxModal);
    console.log("toolboxModal.activeObject -> ",toolboxModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalToolbox())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {toolboxModal.activeObject &&
              <h1>{toolboxModal.activeObject.data_blob.data_tier.partner}</h1>}
              {toolboxModal.activeObject===null &&
              <h1>{"<Nouvel hotel du mois>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {toolbox_form}
                company_guid = {globals.datasync.toolbox_company_guid}
                table_guid= {globals.datasync.tbx_partners_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Partenaire Toolbox enregistré"})); console.log("ToolboxFormDialog::saved_data ->",saved_data);dispatch(addToolboxPartner(saved_data)); dispatch(closeModalToolbox());}}
                //Let us update the articl
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Partenaire Toolbox modifié"})); console.log("ToolboxFormDialog::updated_data ->",updated_data); dispatch(updateToolboxPartner(updated_data)); dispatch(closeModalToolbox());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur du Partenaire Toolbox"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalToolbox())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {toolboxModal.activeObject}
                data_blob = {toolboxModal.activeObject?toolboxModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {toolboxModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default ToolboxPartnerFormDialog;
